module.exports = __webpack_public_path__ + "static/364086_1_0-9d3f3f56bf66cb8d4bcd3439303d3d6d.woff";